import { createSlice } from "@reduxjs/toolkit"
import { EMAIL_ENTRIES } from "../../../constants/reducer_names"

const initialState = {
    checkEmailArray: [] as any,
    isNewEmailEntry: false,
    isNewEmailEntryConnected: false,
    isMessageRecived: [] as any
}


const newEmailEntriesSlice = createSlice({
    name: EMAIL_ENTRIES,
    initialState,
    reducers: {
        checkNewEmail: (state, { payload }) => {
            state.checkEmailArray = payload.checkEmailArray
            state.isNewEmailEntry = payload.isNewEmailEntry
        },

        isEmailConnected: (state, { payload }) => {
            state.isNewEmailEntry = payload.isNewEmailEntry

            // state.isNewEmailEntryConnected = payload.isNewEmailEntryConnected
        },
        isEmailReceived: (state, { payload }) => {
            state.isNewEmailEntry = payload.isNewEmailEntry
            state.isMessageRecived = payload.isMessageRecived
        },
        reset: () => { },
    }
})

export const newEmailEntriesSliceActions = newEmailEntriesSlice.actions;
export const newEmailEntriesSliceReducer = newEmailEntriesSlice.reducer; 